import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UseInterval from '@/js/common/UseInterval';
import { useRecoilState } from 'recoil';
import * as Atom from '@/js/common/Atom';
import Util from '@/js/common/Util';
import Axios from '@/js/common/Axios';
import AppContext from '@/js/common/AppContext';
import Modal from '@/js/common/ui/modal/Modal';
import { removeCookie } from "@/js/common/Cookie";
import Button from '../common/ui/Button';
import DialogTitleBar from '../system/common/DialogTitleBar';

export const getTokenCrtDt = () => {
    return localStorage.getItem("tokenCrtDt");
}
export const setTokenCrtDt = () => {
    const tokenCrtDt = Util.getSpecificDate("-", "day", 0, "SS", "");
    if (tokenCrtDt !== undefined) {
        localStorage.setItem("tokenCrtDt", tokenCrtDt);
    }
}

export const removeTokenCrtDt = () => {
    localStorage.removeItem("tokenCrtDt");
    removeCookie("tokenCrtDt");
}

const TokenCheck = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // const setIsAdmin = useSetRecoilState(Atom.isAdmin);
    const [userInfo, setUserInfo] = useRecoilState(Atom.userInfo);
    const [remainTimeText, setRemainTimeText] = React.useState<string>('');
    const [timeOutModalOpen, setTimeOutModalOpen] = React.useState<boolean>(false);

    UseInterval(() => {
        if (!AppContext.refreshTokenExpireTime) {
            history.go(0);
        }
        const tokenCrtDt = getTokenCrtDt();
        if (tokenCrtDt === null || tokenCrtDt === undefined) { // 토큰정보 없으면
            setTimeOutModalOpen(false);
            if (location.pathname !== '/' && !location.pathname.startsWith('/portal', 0)) {
                // 전체권한 페이지 아닐 때에만
                AppContext.goLogout(); // 로그인페이지로 리다이렉트
            } else if (location.pathname === '/' || location.pathname === '/portal/index') {
                navigate("/portal/login");
            }
            return;
        }
        if (location.pathname.startsWith('/portal/login', 0)) {
            // 토큰 발급 후에도 계속 로그인 페이지면
            if (Util.isNotEmpty(userInfo.userId)) {
                navigate("/"); // 메인페이지로
            }
        }
        if (Util.isEmpty(userInfo.userId)) {
            Axios.dataAccess({
                url: "system/user/select-user-info.do",
                methodType: 'post',
                onSuccessFn: (res: any) => {
                    setUserInfo(res.item);
                    // setIsAdmin(res.item.mngrYn === "Y");
                },
            });
        }
        const nowDt = new Date(Util.getSpecificDate('-', 'day', 0, 'SS', '') as string);
        const calTime = +nowDt - +new Date(tokenCrtDt);
        const remainTime = AppContext.refreshTokenExpireTime * 60000 - calTime; // 접근토큰 만료 계산
        if (remainTime < 600000 && remainTime > 0) {
            // eslint-disable-next-line no-console
            console.log('로그아웃까지 ' + Util.cvtSecToTime(remainTime / 1000) + '초 남음..'); // 로그아웃 임박
            setRemainTimeText(Util.cvtSecToTime(remainTime / 1000));
            setTimeOutModalOpen(true);
        } else if (remainTime <= 0) { // 만료
            Axios.removeAuthInfo();
            navigate('/portal/login'); // 로그인 페이지로 이동
            setTimeOutModalOpen(false);
        } else {
            setTimeOutModalOpen(false);
            if (timeOutModalOpen) {
                AppContext.hideSpinner();
            }
        }
    }, 1000);

    return (
        <Modal
            modalOpen={timeOutModalOpen}
            width={500}
            dim={true}
            visible={true}
            titleEl={<DialogTitleBar title="접속시간 만료 안내" backgroundColor={AppContext.themeColor} />}
        >
            <div className='p20'>
                <span className="fm-b fs17 ls09 fc222222">
                    <span className="fwB">{remainTimeText}</span> 후 로그아웃 됩니다.
                </span>
                <br />
                <br />
                <span className="fm-b fs17 ls09 fc222222">
                    사용 시간을 연장하시려면 하단의 사용시간 연장 버튼을 클릭하세요.
                </span>
                <div className="w100p dpFlx aiC jcC pt40">
                    <Button
                        buttonName="사용시간 연장"
                        backgroundColor={AppContext.themeColor}
                        width={210}
                        height={56}
                        borderRadius={10}
                        buttonClass='jcC'
                        fontFamily='fm-b'
                        fontSize={15}
                        letterSpacing={-0.6}
                        color="#fff"
                        onClickFunc={() => {
                            AppContext.showSpinner("1", 0.5);
                            Axios.tokenReIssuance();
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};
export default TokenCheck;
